import classNames from "classnames";
import React, {PropsWithChildren} from "react";
import {WrappedTextComponent} from '~/ok/components/base/Icon/mob/WrappedTextComponent';
import {sizeCssClass} from "../lib/iconHelpers";
import {IBaseMobIconProps} from "./types";


interface IFontIconProps extends IBaseMobIconProps, PropsWithChildren {
    fontIconCssClass?: string;
}

interface ISpriteIconProps extends IBaseMobIconProps {
    spriteIconCssClass?: string;
}

export const TextIcon: React.FC<IFontIconProps & ISpriteIconProps> = ({
    fontIconCssClass,
    spriteIconCssClass,
    size = "16",
    modifierSupplier,
    textClassName,
    isMultiline,
    hasTextComponent,
    reverseOrder,
    title,
    children,
    attrs,
}) => {
    const rootClassName = classNames(
        fontIconCssClass,
        spriteIconCssClass,
        modifierSupplier,
        {
            'fi': Boolean(fontIconCssClass),
            'ic': Boolean(spriteIconCssClass),
            "__multiline": isMultiline,
            "__empty": !hasTextComponent,
            "__rt": reverseOrder,
        },
        sizeCssClass(size)
    );
    return (
        <span className={rootClassName} title={title} {...attrs}>
            {children && (<WrappedTextComponent textComponent={children} modifier={textClassName} />)}
        </span>
    );
};
